import Form from 'components/Form';

import { Fragment } from 'react';
import { Grid, Typography } from '@mui/material';

import RowContainer from '../components/RowContainer';

import { Ti18nId } from 'hooks/useI18n';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../components/SectionTitle';
import { Stack } from '@mui/system';
import RowContent from '../components/RowContent';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  onRequired: (id: Ti18nId) => void;
  onSuccess: (message: string) => void;
}

const checks = [
  {
    label: '步行',
    key: 'recommendation1.checked1',
  },
  {
    label: '輪椅',
    key: 'recommendation1.checked2',
  },
  {
    label: '推車',
    key: 'recommendation1.checked3',
  },
  {
    label: '床',
    key: 'recommendation1.checked4',
  },
];

const checks2 = [
  {
    label: '无',
    key: 'recommendation2_monitor_o2.checked1',
  },
  {
    label: '存在',
    key: 'recommendation2_monitor_o2.checked2',
  },
];

const checks3 = [
  {
    label: '无',
    key: 'recommendation2_monitor_patients.checked1',
  },
  {
    label: '存在',
    key: 'recommendation2_monitor_patients.checked2',
  },
];

const Recommendation = (props: Props) => {
  const { disabled, register, getValues, setValue } = props;

  return (
    <Fragment>
      <SectionTitle title="R (recommendation, 建議)" />
      <RowContainer
        xs={12}
        sx={{ margin: '20px 0px 30px 0px', marginLeft: '-25px' }}
      >
        <RowContent title="預定檢查" titleRatio={1.2} childrenRatio={10.8}>
          <Form.MuiTextField
            required={false}
            fullWidth
            disabled={disabled}
            placeholder="輸入"
            {...register('recommendation1_input1')}
          />
        </RowContent>
        <RowContent title="轉移方式" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            {checks.map((v, i) => {
              return (
                <Grid item xs={1.5}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="監測" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.5}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                氧氣
              </Typography>
            </Grid>
            {checks2.map((v, i) => {
              return (
                <Grid item xs={i === 0 ? 1.5 : 0.7}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
            <Form.MuiTextField
              required={false}
              sx={{ width: '190px' }}
              disabled={disabled}
              placeholder="手動輸入"
              InputProps={{ ...Form.adornment('', 'L/min') }}
              {...register(`recommendation2_monitor_o2_input`)}
            />
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.5}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                病人監測
              </Typography>
            </Grid>
            {checks3.map((v, i) => {
              return (
                <Grid item xs={i === 0 ? 1.5 : 0.5}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.5}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                其他
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Stack direction="row">
                <Form.MuiTextField
                  required={false}
                  fullWidth
                  disabled={disabled}
                  placeholder="輸入"
                  {...register(`recommendation2_monitor_etc_input`)}
                />
              </Stack>
            </Grid>
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={0} childrenRatio={12}>
          <Form.MuiTextField
            required={false}
            fullWidth
            multiline
            minRows={3}
            disabled={disabled}
            placeholder="請指定其他詳細信息。"
            {...register(`recommendation2_etc_input`)}
          />
        </RowContent>
      </RowContainer>
    </Fragment>
  );
};

export default Recommendation;
